/**
 *  Maximum allowed time.
 *  @constant
 *  @type {number}
 *  @default
 */export var maxTime=Math.pow(10,8)*24*60*60*1000;/**
 *  Minimum allowed time.
 *  @constant
 *  @type {number}
 *  @default
 */export var minTime=-maxTime;